import {
  SCALE_SELECTED_CLEAR,
  SCALE_SELECTED_SET,
  SCALES_FETCH,
  SCALES_SET,
} from "./scaleActions";

const defaultState = { list: [], selectedId: null, fetching: false };
export default function (state = defaultState, action) {
  switch (action.type) {
    case SCALES_FETCH:
      return {
        ...state,
        fetching: action.fetching === undefined ? true : action.fetching,
      };
    case SCALES_SET:
      return {
        ...state,
        fetching: false,
        list: action.scales,
      };
    case SCALE_SELECTED_SET:
      return {
        ...state,
        fetching: false,
        selectedId: action.id,
      };
    case SCALE_SELECTED_CLEAR:
      return {
        ...state,
        selectedId: null,
      };
    case "LOGOUT":
      return defaultState;
    default:
      return state;
  }
}
